module.exports = __webpack_public_path__ + "img/highlighted.240909b4.svg";